import React from 'react';

export interface TooltipProps {
    content: string;
    children: React.ReactNode;
    side?: 'top' | 'bottom' | 'left' | 'right';
    className?: string;
}

const sideClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
};

const Tooltip: React.FC<TooltipProps> = ({ content, children, side = 'top', className = '' }) => {
    const [visible, setVisible] = React.useState(false);

    return (
        <span
            className={`relative inline-flex ${className}`}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            {visible && (
                <span className={`absolute z-50 w-max max-w-64 whitespace-normal wrap-break-word rounded-lg bg-slate-800 px-2.5 py-1.5 text-xs leading-snug text-white shadow-lg pointer-events-none ${sideClasses[side]}`}>
                    {content}
                </span>
            )}
        </span>
    );
};

Tooltip.displayName = 'Tooltip';
export default Tooltip;
